import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

export interface AllocationDecisionDialogData {
	carrierBusinessName: string;
	existingAllocation?: {
		allocationType: string;
		allocationValue: number;
		allocationPeriod: string;
	};
}

export interface AllocationDecisionResult {
	decision: 'configure' | 'skip';
}

@Component({
	selector: 'app-allocation-decision-dialog',
	templateUrl: './allocation-decision-dialog.component.html',
	styleUrls: ['./allocation-decision-dialog.component.scss'],
})
export class AllocationDecisionDialogComponent implements OnInit {
	carrierBusinessName: string;
	hasExistingAllocation: boolean = false;
	existingAllocationSummary: string = '';

	constructor(
		public dialogRef: MatDialogRef<AllocationDecisionDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public dialogData: AllocationDecisionDialogData
	) {
		this.carrierBusinessName = dialogData.carrierBusinessName;
		this.hasExistingAllocation = !!dialogData.existingAllocation;

		if (this.hasExistingAllocation) {
			const { allocationType, allocationValue, allocationPeriod } = dialogData.existingAllocation;
			const typeLabel = allocationType === 'PERCENTAGE' ? `${allocationValue}%` : `${allocationValue} loads`;
			const periodLabel = allocationPeriod.toLowerCase();
			this.existingAllocationSummary = `${typeLabel} ${periodLabel}`;
		}
	}

	ngOnInit(): void {}

	onConfigure(): void {
		this.dialogRef.close({ decision: 'configure' } as AllocationDecisionResult);
	}

	onSkip(): void {
		this.dialogRef.close({ decision: 'skip' } as AllocationDecisionResult);
	}

	onClose(): void {
		this.dialogRef.close(null);
	}
}
